import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { tenant_auth_actions_helper } from '../../../../actions/actions_helper';
import { RETRIEVE_TENANT_ORDERS_ANALYTICS_API } from '../../../../api/api_data';
import { fail_retrieve_tenant_order_analytics, loading_retrieve_tenant_order_analytics, reset_retrieve_tenant_order_analytics, success_retrieve_tenant_order_analytics } from '../../../../reducers/auth_tenant/retrieve_tenant_order_analytics_Slice';
import { RETRIEVE_TENANT_ORDER_ANALYTICS_ERROR_MSG, RETRIEVE_TENANT_ORDER_ANALYTICS_SUCCESS_MSG } from '../../../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { addThreeDots, formatToSentenceCase, messageToast } from '../../../../utils/Utils';
import { Block, BlockBetween, BlockHead, BlockHeadContent, Button, Col, DataTableBody, DataTableHead, DataTableItem, DataTableRow, Icon, Row } from '../../../../components/Component';
import { Link } from 'react-router-dom';
import AuthTenantLoader from '../../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../../error/AuthTenantPageError';
import { Badge, Card, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import * as app_consts from "../../../../utils/app_consts";
import { Pie } from 'react-chartjs-2';
import { Chart, CategoryScale, LinearScale, BarElement, PointElement, LineElement, ArcElement, Tooltip, Filler, Legend } from "chart.js";
import moment from 'moment';

Chart.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, ArcElement, Tooltip, Filler, Legend);

const OrderAnalyticsData = ({ tenant_info, user_info }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page_data, setPageData] = useState();
  const [status_labels, setStatusLabels] = useState([]);
  const [status_values, setStatusValues] = useState([]);

  const dispatch = useDispatch();

  useEffect(() => {
    retrive_order_analytics();
  }, []);

  const retrive_order_analytics = () => {
    setError("");
    setLoading(true);
    dispatch(tenant_auth_actions_helper(
      loading_retrieve_tenant_order_analytics,
      success_retrieve_tenant_order_analytics,
      fail_retrieve_tenant_order_analytics,
      RETRIEVE_TENANT_ORDER_ANALYTICS_ERROR_MSG,
      RETRIEVE_TENANT_ORDER_ANALYTICS_SUCCESS_MSG,
      app_consts.GET,
      `/${tenant_info?.url_prefix}/${RETRIEVE_TENANT_ORDERS_ANALYTICS_API}`
    ));
  };

  const retrieve_tenant_order_analytics_listener = useSelector(
    (state) => state.retrieve_tenant_order_analytics.retrieve_tenant_order_analytics
  );

  useEffect(() => {
    if (retrieve_tenant_order_analytics_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_order_analytics_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_tenant_order_analytics_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_tenant_order_analytics_listener.message);
          messageToast(retrieve_tenant_order_analytics_listener.message, app_consts.FAIL);
        } else if (retrieve_tenant_order_analytics_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_tenant_order_analytics_listener.data);
          setStatusLabels(retrieve_tenant_order_analytics_listener.data?.status_count?.map((stat) =>
            formatToSentenceCase(stat?.label)
          ));
          setStatusValues(retrieve_tenant_order_analytics_listener.data?.status_count?.map((stat) => stat?.value));

          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          return () => clearTimeout(timer);
        }
        dispatch(reset_retrieve_tenant_order_analytics());
      }
    }
  }, [retrieve_tenant_order_analytics_listener]);

  const status_piechart_data = {
    labels: status_labels,
    datasets: [{
      data: status_values,
      backgroundColor: ["#6576ff", "#8e9dff", "#b1bcff", "#d0d7ff", "#e3e7fe"],
      borderWidth: 0
    }]
  };

  const pieOptions = {
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          usePointStyle: true,
          padding: 20,
          font: {
            family: "'Inter', sans-serif",
            size: 12
          }
        }
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const label = context.label || '';
            const value = context.raw || 0;
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const percentage = Math.round((value / total) * 100);
            return `${label}: ${value} (${percentage}%)`;
          }
        }
      }
    },
    cutout: '70%',
    maintainAspectRatio: false
  };

  const cardStyle = {
    borderRadius: '8px',
    border: '1px solid #e5e9f2',
    transition: 'all 0.3s ease',
    marginBottom: 0,
    height: '100%',
    ':hover': {
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
      transform: 'translateY(-2px)'
    }
  };

  const statIconStyle = {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px'
  };

  return (
    <div style={{ padding: '0 15px', marginTop: '20px' }}>
      <BlockHead size="sm">
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '20px'
        }}>
          <BlockHeadContent>
            <h4 style={{
              margin: 0,
              fontWeight: '600',
              color: '#1a1a1a',
              fontSize: '20px'
            }}>
              Order Analytics
            </h4>
            <p style={{
              color: '#6c757d',
              margin: '5px 0 0 0',
              fontSize: '14px'
            }}>
              Overview of your order statistics and recent activity
            </p>
          </BlockHeadContent>
        </div>
        {!loading && (
          <BlockBetween>
            <BlockHeadContent>

              <Button
                color="light"
                outline
                style={{
                  backgroundColor: 'white',
                  display: 'inline-flex',
                  alignItems: 'center',
                  padding: '8px 12px'
                }}
                onClick={(e) => { e.preventDefault(); retrive_order_analytics(); }}
              >
                <span>Refresh</span>
              </Button>
            </BlockHeadContent>
            <BlockHeadContent>
              {/* <UncontrolledDropdown>
                <DropdownToggle
                  color="transparent"
                  className="dropdown-toggle dropdown-indicator btn btn-outline-light btn-white"
                >
                  All
                </DropdownToggle>
                <DropdownMenu end>
                  <ul className="link-list-opt no-bdr">
                    <li>
                      <DropdownItem tag="a" href="#dropdownitem" onClick={(ev) => ev.preventDefault()}>
                        <span>Weekly</span>
                      </DropdownItem>
                    </li>
                    <li>
                      <DropdownItem tag="a" href="#dropdownitem" onClick={(ev) => ev.preventDefault()}>
                        <span>Featured</span>
                      </DropdownItem>
                    </li>
                    <li>
                      <DropdownItem tag="a" href="#dropdownitem" onClick={(ev) => ev.preventDefault()}>
                        <span>Out of Stock</span>
                      </DropdownItem>
                    </li>
                  </ul>
                </DropdownMenu>
              </UncontrolledDropdown> */}
            </BlockHeadContent>


          </BlockBetween>
        )}
      </BlockHead>

      {loading ? (
        <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Order Analytics..." />
      ) : error ? (
        <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
      ) : (
        <Block style={{ marginTop: '15px' }}>
          <Row className="g-gs" style={{ marginBottom: '20px' }}>
            {/* Stats Cards */}
            <Col xxl="3" sm="6" style={{ marginBottom: '20px' }}>
              <Card style={cardStyle}>
                <div style={{ padding: '20px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div>
                      <h6 style={{
                        fontSize: '14px',
                        color: '#6c757d',
                        marginBottom: '8px',
                        fontWeight: '500'
                      }}>
                        Total Orders
                      </h6>
                      <h2 style={{
                        fontSize: '24px',
                        fontWeight: '600',
                        margin: 0,
                        color: '#1a1a1a'
                      }}>
                        {page_data?.no_of_orders || "0"}
                      </h2>
                    </div>
                    <div style={{ ...statIconStyle, backgroundColor: 'rgba(101, 118, 255, 0.1)' }}>
                      <Icon name="cart" style={{ color: '#6576ff' }} />
                    </div>
                  </div>
                </div>
              </Card>
            </Col>

            <Col xxl="3" sm="6" style={{ marginBottom: '20px' }}>
              <Card style={cardStyle}>
                <div style={{ padding: '20px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div>
                      <h6 style={{
                        fontSize: '14px',
                        color: '#6c757d',
                        marginBottom: '8px',
                        fontWeight: '500'
                      }}>
                        Order Types
                      </h6>
                      <h2 style={{
                        fontSize: '24px',
                        fontWeight: '600',
                        margin: 0,
                        color: '#1a1a1a'
                      }}>
                        {page_data?.order_type_count?.length || "0"}
                      </h2>
                    </div>
                    <div style={{ ...statIconStyle, backgroundColor: 'rgba(25, 162, 255, 0.1)' }}>
                      <Icon name="tags" style={{ color: '#19a2ff' }} />
                    </div>
                  </div>
                </div>
              </Card>
            </Col>

            <Col xxl="3" sm="6" style={{ marginBottom: '20px' }}>
              <Card style={cardStyle}>
                <div style={{ padding: '20px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div>
                      <h6 style={{
                        fontSize: '14px',
                        color: '#6c757d',
                        marginBottom: '8px',
                        fontWeight: '500'
                      }}>
                        Consigners
                      </h6>
                      <h2 style={{
                        fontSize: '24px',
                        fontWeight: '600',
                        margin: 0,
                        color: '#1a1a1a'
                      }}>
                        {page_data?.consigner_count?.length || "0"}
                      </h2>
                    </div>
                    <div style={{ ...statIconStyle, backgroundColor: 'rgba(239, 87, 119, 0.1)' }}>
                      <Icon name="users" style={{ color: '#ef5777' }} />
                    </div>
                  </div>
                </div>
              </Card>
            </Col>

            <Col xxl="3" sm="6" style={{ marginBottom: '20px' }}>
              <Card style={cardStyle}>
                <div style={{ padding: '20px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div>
                      <h6 style={{
                        fontSize: '14px',
                        color: '#6c757d',
                        marginBottom: '8px',
                        fontWeight: '500'
                      }}>
                        Date Types
                      </h6>
                      <h2 style={{
                        fontSize: '24px',
                        fontWeight: '600',
                        margin: 0,
                        color: '#1a1a1a'
                      }}>
                        {page_data?.order_date_type_count?.length || "0"}
                      </h2>
                    </div>
                    <div style={{ ...statIconStyle, backgroundColor: 'rgba(136, 108, 255, 0.1)' }}>
                      <Icon name="calendar" style={{ color: '#886cff' }} />
                    </div>
                  </div>
                </div>
              </Card>
            </Col>

            {/* Status Pie Chart */}
            <Col xxl="3" md="6" style={{ marginBottom: '20px' }}>
              <Card style={{
                borderRadius: '8px',
                border: '1px solid #e5e9f2',
                height: '100%',
                overflow: 'hidden'
              }}>
                <div style={{ padding: '20px' }}>
                  <div style={{ marginBottom: '16px' }}>
                    <h6 style={{
                      fontSize: '16px',
                      fontWeight: '500',
                      margin: 0,
                      color: '#1a1a1a'
                    }}>
                      Order Status Distribution
                    </h6>
                  </div>
                  <div style={{
                    height: '200px',
                    position: 'relative',
                    marginBottom: '16px'
                  }}>
                    <Pie data={status_piechart_data} options={pieOptions} />
                  </div>
                  <div style={{ marginTop: '12px' }}>
                    {page_data?.status_count?.map((stat, index) => (
                      <div key={index} style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '8px',
                        fontSize: '14px'
                      }}>
                        <span style={{
                          width: '10px',
                          height: '10px',
                          borderRadius: '50%',
                          marginRight: '8px',
                          backgroundColor: status_piechart_data.datasets[0].backgroundColor[index]
                        }} />
                        <span style={{
                          flex: 1,
                          color: '#526484'
                        }}>
                          {formatToSentenceCase(stat?.label) || "--"}
                        </span>
                        <span style={{
                          fontWeight: '500',
                          color: '#1a1a1a'
                        }}>
                          {stat?.value || 0}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </Card>
            </Col>

            {/* Recent Orders Table */}
            <Col xxl="9" style={{ marginBottom: '20px' }}>
              <Card style={{
                borderRadius: '8px',
                border: '1px solid #e5e9f2'
              }}>
                <div style={{
                  padding: '16px 20px',
                  borderBottom: '1px solid #e5e9f2',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}>
                  <h6 style={{
                    fontSize: '16px',
                    fontWeight: '500',
                    margin: 0,
                    color: '#1a1a1a'
                  }}>
                    Recent Orders
                  </h6>
                  <Link to={`/${tenant_info.url_prefix}/orders`} style={{
                    color: '#6576ff',
                    textDecoration: 'none',
                    fontWeight: '500',
                    fontSize: '14px',
                    ':hover': {
                      textDecoration: 'underline'
                    }
                  }}>
                    View All
                  </Link>
                </div>
                <div style={{ padding: '20px' }}>
                  <div className="nk-tb-list">
                    <DataTableHead>
                      <DataTableRow>
                        <span>Order No.</span>
                      </DataTableRow>
                      <DataTableRow size="sm">
                        <span>Customer</span>
                      </DataTableRow>
                      <DataTableRow size="md">
                        <span>Date</span>
                      </DataTableRow>
                      <DataTableRow>
                        <span>Products</span>
                      </DataTableRow>
                      <DataTableRow>
                        <span>Status</span>
                      </DataTableRow>
                    </DataTableHead>
                    {page_data?.recent_orders ? (
                      page_data?.recent_orders?.map((item, idx) => (
                        <DataTableItem key={item.id}>
                          <DataTableRow size="sm">
                            <Link to={`/${tenant_info.url_prefix}/orders/${item?.order_ref_number}`} style={{ color: '#1a1a1a', textDecoration: 'none' }}>
                              <span className="tb-product">
                                <span className="title">{item?.order_ref_number || "--"}</span>
                              </span>
                            </Link>
                          </DataTableRow>
                          <DataTableRow size="sm">
                            <div className="user-card">
                              <div className="user-name">
                                <span className="tb-lead" style={{ color: '#526484' }}>
                                  {item?.sales_rep?.name ? addThreeDots(item?.sales_rep?.name, 30) : "--"}
                                </span>
                              </div>
                            </div>
                          </DataTableRow>
                          <DataTableRow size="md">
                            <span className="tb-sub" style={{ color: '#526484' }}>
                              {item?.inserted_at ? moment(item?.inserted_at).format("MMM D, YYYY h:mm A") : "--"}
                            </span>
                          </DataTableRow>
                          <DataTableRow>
                            <span className="tb-sub tb-amount" style={{ color: '#526484' }}>
                              {item?.no_of_products || 0}
                            </span>
                          </DataTableRow>
                          <DataTableRow>
                            <Badge
                              className="badge-dot badge-dot-xs"
                              color={
                                item?.status === app_consts.DISPATCHED_LOWER || item?.status === app_consts.APPROVED_LOWER
                                  ? "success"
                                  : "warning"
                              }
                              style={{
                                fontSize: '12px',
                                padding: '4px 8px',
                                fontWeight: '500'
                              }}
                            >
                              {item?.status ? formatToSentenceCase(item?.status)?.toUpperCase() : "--"}
                            </Badge>
                          </DataTableRow>
                        </DataTableItem>
                      ))
                    ) : (
                      <div style={{ padding: '20px', textAlign: 'center' }}>
                        <p style={{ color: '#6c757d', margin: 0 }}>No orders found</p>
                      </div>
                    )}
                  </div>
                </div>
              </Card>
            </Col>
          </Row>
        </Block>
      )}
    </div>
  );
};

export default OrderAnalyticsData;